module.exports = __webpack_public_path__ + "img/knowledge.85ea6d0d.svg";